
import { apiClient } from "./apiClient";

export const DM_CAUHINH_EMAIL = "admission-helper/dm_cauhinh_email_select_all"

export const admissionHelperApi = {
    dm_cauhinh_email_select_all: () => apiClient.post(DM_CAUHINH_EMAIL)
}